module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/ic-pending@2x.d11ea23a.png";